export enum EdoCircularVisibility {
  ALL = 'ALL',

  STUDENTS = 'STUDENTS',

  TEACHERS = 'TEACHERS',
}
